import workspaceQuery from 'graphql/queries/nominal/NominalBudgetProfileWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalBudgetProfileListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalBudgetProfileQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalBudgetProfileDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalBudgetProfileMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalBudgetProfileFragment.graphql';

const NominalBudgetProfile = {
  type: 'NominalBudgetProfile',
  title: 'Nominal Budget Profiles',
  formTitle: 'Nominal Budget Profile',
  formUrl: '/Nominal/BudgetProfile/Details/',
  workspaceUrl: '/Nominal/BudgetProfile/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'NOMINAL_BUDGET_PROFILES',
};

export default NominalBudgetProfile;
